import React, { useEffect, useRef, useState } from 'react'
import styles from "./gif.module.css"
import MediaUnavailable from '../MediaUnavailable'

const MAX_PLAYS = 3
const MAX_WIDTH = 280
const MAX_HEIGHT = 240

const getGifStyle = (width, height, quotedMessage) => {
    if (quotedMessage) return {}

    if (width > 0 && height > 0) {
        const scale = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height, 1)
        const displayWidth = Math.round(width * scale)
        return {
            width: `min(${displayWidth}px, 70vw)`,
            aspectRatio: `${width} / ${height}`,
        }
    }

    return {}
}

const getAttributionLabel = (attribution) => {
    const value = `${attribution || ""}`.toLowerCase()
    if (value === "1" || value.includes("giphy")) return "GIPHY"
    if (value === "2" || value.includes("tenor")) return "TENOR"

    return attribution
}

const Gif = ({ url, width, height, attribution, quotedMessage = false }) => {
    const [playGif, setPlayGif] = useState(false)
    const [failed, setFailed] = useState(false)

    const videoRef = useRef(null)
    const playCountRef = useRef(0)

    const style = getGifStyle(width, height, quotedMessage)

    useEffect(() => setFailed(false), [url])

    useEffect(() => {
        if (!quotedMessage) {
            if (playGif) {
                videoRef?.current?.play().catch(() => { })
            } else {
                videoRef?.current?.pause()
            }
        }
    }, [playGif, quotedMessage])

    const tooglePlayGif = () => {
        if (!quotedMessage) {
            const video = videoRef.current
            if (!playGif && video) {
                video.currentTime = 0
                playCountRef.current = 0
            }
            setPlayGif(previousValue => !previousValue)
        }
    }

    const handleEnded = () => {
        if (quotedMessage) return

        playCountRef.current += 1

        if (playCountRef.current >= MAX_PLAYS) {
            setPlayGif(false)
            return
        }

        if (videoRef.current) {
            videoRef.current.currentTime = 0
            videoRef.current.play().catch(() => { })
        }
    }

    const showPlayOverlay = !quotedMessage && !playGif
    const attributionLabel = getAttributionLabel(attribution)
    const showCredit = !quotedMessage && attributionLabel

    const handleLoadedMetadata = () => {
        if (quotedMessage && videoRef.current) {
            videoRef.current.currentTime = 0
        }
    }

    if (failed) {
        return <MediaUnavailable type="gif" compact={quotedMessage} onRetry={() => setFailed(false)} />
    }

    return (
        <div className={styles.container} onClick={tooglePlayGif}>
            {showPlayOverlay &&
                <div className={styles.playGif}>
                    GIF
                </div>

            }
            <video
                src={url}
                alt="GIF"
                controls={false}
                autoPlay={false}
                muted={true}
                loop={false}
                playsInline
                preload="metadata"
                ref={videoRef}
                style={style}
                onEnded={handleEnded}
                onLoadedMetadata={handleLoadedMetadata}
                onError={() => setFailed(true)}
            />
            {showCredit && <span className={styles.credit}>{attributionLabel}</span>}
        </div>
    )
}

export default Gif
